export enum TranslationsKeys {
  // Global
  TERMS = 'terms',
  COMMON = 'common',
  OLD_TRANSLATIONS = 'translation',
  STUDY_PLAN_ENROLLMENT_STATUS = 'study-plan-enrollment-status',
  // Peticiones
  PETITIONS = 'petitions',
  SURVEY = 'survey',
  // announcements
  ANNOUNCEMENTS_LIST = 'announcements/list',
  // degree-processes
  DEGREE_POOCESSES_DOCUMENTS = 'degree-processes/documents',
  DEGREE_POOCESSES_MAIN = 'degree-processes/main',
}

export const TranslatonsArray = Object.values(TranslationsKeys);
